<app-header #header></app-header>

<ion-content>
  <div class="container">

    <ion-card class="parent-one">
      <div class="rich-text" [innerHTML]="rankingResponse?.ranking?.description"></div>
    </ion-card>
  
    <ion-card class="parent-two">
      <h6><strong>TU PROGRESO ACTUAL</strong></h6>
      <div class="semaforo-horizontal">
        <div class="progress-meter"
          [style.left.%]="progress">
          <ion-icon name="caret-down-outline"></ion-icon>
          <span>{{ progress }}% <br>Tu avance </span>
        </div>
        <div class="level rojo">
          <span>Debes seguir</span>
        </div>
        <div class="level naranja">
          <span>A punto de ganar!</span>
        </div>
        <div class="level verde">
          <span>Grupo ganador</span>
        </div>
      </div>
      <h6 *ngIf="rankingResponse?.player_data?.total_invoices" ><strong>Total de facturas subidas en el período: {{rankingResponse?.player_data?.total_invoices}}</strong></h6>
      <h6 *ngIf="rankingResponse?.player_data?.total_points"><strong>Total de {{ companyInfo?.points_name }} acumulados en el período: {{rankingResponse?.player_data?.total_points |
            currency : 'COP':''}}</strong></h6>

      <span style="color: var(--ion-color-primary); font-size: 15px;" 
            *ngIf="rankingResponse?.ranking?.ranking_type === 'type_points' && rankingResponse?.ranking?.min_value_to_participate > rankingResponse?.player_data?.total_points">
            <strong>Para participar debes tener acumulados minimo {{ rankingResponse?.ranking?.min_value_to_participate |
            currency : 'COP':'' }} {{ companyInfo?.points_name }} en el periodo</strong></span>

      <span style="color: var(--ion-color-primary); font-size: 15px;" 
            *ngIf="rankingResponse?.ranking?.ranking_type === 'type_invoices' && rankingResponse?.ranking?.min_value_to_participate > rankingResponse?.player_data?.total_invoices">
            <strong>Para participar debes subir minimo {{ rankingResponse?.ranking?.min_value_to_participate }} facturas en el periodo</strong></span>

    </ion-card>
  
    <ion-card class="parent-three">
      <h6><strong>Estado según el avance</strong></h6>
      <div [class.selected]="progress < 33" >Sigue participando para avanzar.</div>
      <div [class.selected]="progress >= 33 && progress <= 66">¡Ya casi! Estás a punto de entrar al grupo ganador.</div>
      <div [class.selected]="progress > 66">¡Felicitaciones! Estás en el grupo ganador.</div>
    </ion-card>
  
    <ion-card class="parent-four">
      <h6><strong>RECOMPENSAS DESTACADAS</strong></h6>
      <div class="card-content">
        <ion-grid>
          <ion-row>

            <ion-col size="12" size-md="6" size-lg="3" *ngFor="let group of groupsArray; let i = index">
              <ion-card [class.selected]="rankingResponse?.player_data.player_group === group.name">
                <ion-card-header>
                  <span>¡Aquí vas!</span>
                  <ion-card-title >{{
                                    group.product?.name
                                    ? group.product.name
                                    : group.points
                                      ? ('Puntos a Ganar ' + group.points)
                                      : 'No disponible'
                                  }}</ion-card-title>
                </ion-card-header>
              </ion-card>
            </ion-col>

          </ion-row>
        </ion-grid>
      </div>
      
    </ion-card>
    <!-- <div class="buttons">
      <ion-button>Ver cómo ganar más</ion-button>
      <ion-button>Ver reglas del programa</ion-button>
    </div> -->
  </div>

</ion-content>
